import React, { useState } from "react";
import DesktopHeader from "./DesktopHeader";
import MobileHeader from "./MobileHeader";
import BottomNavBar from "./BottomNavBar";
import BottomSheetMenu from "./BottomSheetMenu";
import { CartModal } from "../../../ui/modals/CartModal";
import { FavoritesModal } from "../../../ui/modals/FavoritesModal";
import { usePublic } from "../../../../context/PublicContext";

const Header: React.FC = () => {
  const [isBottomSheetOpen, setIsBottomSheetOpen] = useState(false);
  const [isCartOpen, setIsCartOpen] = useState(false);
  const [isFavoritesOpen, setIsFavoritesOpen] = useState(false);
  const { settings } = usePublic();
  const whatsappNumber = settings?.whatsapp_number || "";
  const desktopNavItems = [
    { path: "/", label: "Accueil" },
    { path: "/services", label: "Services" },
    { path: "/projects", label: "Réalisations" },
    { path: "/boutique", label: "Boutique" },
    { path: "/devis", label: "Devis" },   // ← remplacement
  ];

  return (
    <>
      <header className="sticky top-0 z-40 w-full h-14 border-b border-white/10 backdrop-blur-md bg-dark/90">
        <div className="w-full max-w-7xl mx-auto px-4 h-full flex items-center justify-between">
          <DesktopHeader
            onCartClick={() => setIsCartOpen(true)}
            onFavoritesClick={() => setIsFavoritesOpen(true)}
            navItems={desktopNavItems}
          />
          <MobileHeader
            onCartClick={() => setIsCartOpen(true)}
            onFavoritesClick={() => setIsFavoritesOpen(true)}
          />
        </div>
      </header>

      <BottomNavBar onPlusClick={() => setIsBottomSheetOpen(true)} />
      <BottomSheetMenu isOpen={isBottomSheetOpen} onClose={() => setIsBottomSheetOpen(false)} />

      <CartModal isOpen={isCartOpen} onClose={() => setIsCartOpen(false)} />
      <FavoritesModal isOpen={isFavoritesOpen} onClose={() => setIsFavoritesOpen(false)} />
    </>
  );
};

export default Header;